import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_CLOSED, propTypes } from '../../util/types';

import css from './ListingPage.css';

// The closed notice over a closed listing's gallery for visitors. Owners see
// the ListingOwnerBanner instead.
export const ActionBarMaybe = props => {
  const { listing } = props;
  if (listing.attributes.state !== LISTING_STATE_CLOSED) {
    return null;
  }
  return (
    <div className={css.actionBar}>
      <p className={css.closedListingText}>
        <FormattedMessage id="ListingPage.closedListing" />
      </p>
    </div>
  );
};

ActionBarMaybe.propTypes = {
  listing: propTypes.listing.isRequired,
};

ActionBarMaybe.displayName = 'ActionBarMaybe';

export default ActionBarMaybe;
